import React from 'react';

export default function DailyTotal({ hours, missingDescription }) {
  let className = 'daily-total';
  if (hours > 24) className += ' over-limit';
  else if (missingDescription) className += ' warn-desc';
  else if (hours > 8) className += ' over';
  else if (hours === 8) className += ' full';
  else className += ' partial';

  return (
    <span className={className}>
      Daily: {hours.toFixed(2)} hrs
      {hours === 8 && !missingDescription ? ' \u2713' : ''}
      {hours > 24 ? ' (over 24)' : hours > 8 ? ' (over 8)' : ''}
      {missingDescription && hours <= 24 ? ' (missing description)' : ''}
    </span>
  );
}
